import styled from "styled-components";
import {
  FooterSection,
  LeadingTitle,
} from "@components";
import Content from "./Components/Content";
import { useState, useEffect } from "react";
import { ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";

const InvestorContainer = styled.div`
  background-color: #F9F9F9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const FinancialReport = function () {
  const {t} = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);
  useEffect(() => {
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "lap_keuangan" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadData();
    }
  }, [shortDesc]);
  return (
    <InvestorContainer>
      <LeadingTitle
        title={t("laporan_keuangan")}
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}
      />
      <Content />
      <FooterSection currentPage={t("laporan_keuangan")}/>
    </InvestorContainer>
  );
};

export default FinancialReport;
